module.exports = __webpack_public_path__ + "static/media/icon_therapy.9bd191d5.svg";